import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import Input from '../../components/Input';
import Select from '../../components/Select';
import { connect } from 'react-redux';
import Textarea from '../../components/Textarea';
import { enableAutosave } from '../../redux/actions/general/autosave';
import { __, dateFrom } from '../../core/utils';
import DateTimePicker from '../../components/DateTimePicker';
import styles from '../../../src/styles/forms/stages/EditStageForm.scss';
import classNames from 'classnames';
import Checkbox from '../../components/Checkbox';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import Tooltip from '../../components/Tooltip';
import * as _ from 'lodash';
import WarningIcon from '../../assets/images/tender-icon-warning-16x16.svg';

const mapStateToProps = (state) => {
  return {
    values: getFormValues('stages.details')(state),
    auth: state.auth,
  };
};

@reduxForm({
  form: 'stages.details',
  enableReinitialize: true,
})
@connect(mapStateToProps)
class EditStageForm extends Component {
  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  render() {
    const isDeadline = _.get(this.props.values, 'date.deadline') === 1;
    const status =
      _.get(this.props.values, 'status') ||
      _.get(this.props.initialValues, 'status');
    const disabled =
      !this.props.isProjectAdministrator || status === 'canceled';
    const deadline_date =
      _.get(this.props.values, 'date.deadline_date') ||
      _.get(this.props.initialValues, 'date.deadline_date');
    const deadline_date_formatted =
      deadline_date && dateFrom(deadline_date, true);
    const taskVisibilities = [
      {
        value: '1',
        label: __('tasks.visibility.public'),
      },
      {
        value: '2',
        label: __('tasks.visibility.company', {}, 'My Company'),
      },
      {
        value: '0',
        label: __('tasks.visibility.private'),
      },
    ];

    return (
      <Form onSubmit={this.props.handleSubmit}>
        {/* <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='status'
              component={Select}
              label={__('project-settings.stages.flyout.status')}
              options={stage_statuses}
              noSort
              dropdown
              wrapper={(handleOpen, activeItem, elementRef) => (
                <Tooltip text={__('project-settings.stages.flyout.status')}>
                  <div
                    className={styles.dropdown}
                    ref={elementRef}
                    style={{ background: activeItem.color }}
                    onClick={handleOpen}
                  >
                    <div className={styles.button}>
                      {activeItem.label}
                      <ArrowDownSmallIcon />
                    </div>
                  </div>
                </Tooltip>
              )}
            />
          </div>
          <div className={styles.f1} />
        </div> */}
        <Field
          disabled={disabled}
          localized={this.props.projectLanguages}
          name='name'
          component={Input}
          label={__('project-settings.stages.flyout.title')}
          maxLength={50}
        />
        <Field
          disabled={disabled}
          localized={this.props.projectLanguages}
          name='description'
          component={Textarea}
          label={__('project-settings.stages.flyout.description')}
          maxLength={100}
          rows={1}
          maxRows={10}
        />
        <div className={styles.flex}>
          <div className={styles.visibility}>
            <Field
              disabled={disabled}
              name='default_visibility'
              component={Select}
              label={__(
                'project-settings.stages.flyout.default-task-meeting-visibility',
                {},
                'Default task & meeting visibility'
              )}
              options={taskVisibilities}
              noSort
            />
          </div>
          <div className={classNames(styles.f1, styles.billable)}>
            <div className={styles.billableLabel}>
              {__('project-settings.stages.flyout.billable')}
            </div>
            <Field
              name='billable'
              component={Checkbox}
              // label={__('deadline')}
              className={styles.checkbox}
              onChange={(event) => {}}
              disabled={disabled}
            />{' '}
          </div>
        </div>
        <div className={styles.flex}>
          {deadline_date_formatted && (
            <div className={styles.deadlineIndicator}>
              <Tooltip text={deadline_date_formatted}>
                <span className={styles.deadlineIconBox}>
                  <WarningIcon className={styles.deadlineIcon} />
                </span>
              </Tooltip>
            </div>
          )}
          <div className={styles.f2}>
            <Field
              disabled={disabled}
              name='date'
              component={DateTimePicker}
              label={__('project-settings.stages.flyout.date-range')}
              footer
              range
              lockEndDate={isDeadline}
            />
          </div>
          <div className={classNames(styles.f1, styles.duration)}>
            <Field
              name='date.duration'
              component={Input}
              label={__('project-settings.stages.flyout.duration')}
              placeholder={__('project-settings.stages.flyout.enter-duration')}
              disabled={isDeadline || disabled}
            />
          </div>
          <div className={classNames(styles.f1, styles.deadline)}>
            <div className={styles.deadlineLabel}>
              {__('project-settings.stages.flyout.deadline')}
            </div>
            <Field
              name='date.deadline'
              component={Checkbox}
              // label={__('deadline')}
              className={styles.checkbox}
              onChange={(event) => {}}
              disabled={disabled}
            />{' '}
          </div>
          <div className={classNames(styles.f1, styles.estimate)}>
            <Field
              name='time_log.planned_time'
              component={Input}
              label={__('project-settings.stages.flyout.planned-time')}
              placeholder={__(
                'project-settings.stages.flyout.enter-planned-time'
              )}
              disabled={disabled}
            />
          </div>
        </div>
        {/* <Field
          disabled={!this.props.isProjectAdministrator}
          name='status'
          component={Select}
          label={__('project-settings.stages.flyout.status')}
          options={stage_statuses}
        /> */}
      </Form>
    );
  }
}

export default EditStageForm;
